import TextField from '@Fields/TextField';

class SubmissionSection extends React.Component {

    static modelToState(props) {
        return {
            CurrentSite: props.contactViewModel.CurrentSite,
            Translations: props.contactViewModel.Translations,
            CAPrivacyPolicyNotice: props.contactViewModel.CAPrivacyPolicyNotice,
            ShowFacebookLoginButton: props.contactViewModel.ShowFacebookLoginButton,
            ShowGoogleLoginButton: props.contactViewModel.ShowGoogleLoginButton,
            HighlightErrors: {},
            FormErrors: [],
            InputErrors: {},
        };
    }

    constructor(props) {
        super(props);

        this.state = SubmissionSection.modelToState(props);

        this.handleFieldChanged = this.handleFieldChanged.bind(this);

        //updates the parent's save handler to use this method 
        let masterViewState = this.props.masterViewModel;
        this.state.IsInTranslationEditorMode = this.props.masterViewModel.IsInTranslationEditorMode;

        this.props.handleFormUpdate(masterViewState);
    }

    handleFieldChanged(field, value) {
        if (field !== "ReceiveEmails") {
            return;
        }

        let masterViewState = this.props.masterViewModel;
        let currentContactModel = (masterViewState && masterViewState.ContactViewModel) || this.props.contactViewModel;

        if (!currentContactModel) {
            return;
        }

        masterViewState.ContactViewModel = {
            ...currentContactModel,
            ReceiveEmails: value
        };

        this.props.handleFormUpdate(masterViewState);
    }

    getTranslation(key) {
        return this.state.IsInTranslationEditorMode ?
            <span dangerouslySetInnerHTML={{ __html: this.state.Translations[key] }}></span> :
            this.state.Translations[key];
    }
    //render
    render() {

        let contactModel = (this.props.masterViewModel && this.props.masterViewModel.ContactViewModel) || this.props.contactViewModel || {};
        let isRegisteredUser = !!contactModel.IsRegisteredUser;
        let emailIsRegistered = !!contactModel.EmailIsRegistered;
        let emailVerified = !!contactModel.EmailVerified;
        let showWeeklyUpdateSubscriptionCheckbox = !!contactModel.ShowWeeklyUpdateSubscriptionCheckbox;
        let receiveEmails = contactModel.ReceiveEmails;

        let submitAction = "submit";
        if (!isRegisteredUser && emailIsRegistered && !emailVerified) {
            submitAction = "login";
        }

        //logic to display if a logged in user should have the Receive Weekly Updates logic.
        let WeeklyUpdateCheckboxForLoggedInUser = [];
        if (showWeeklyUpdateSubscriptionCheckbox && (isRegisteredUser || !emailIsRegistered || emailVerified)) {
            WeeklyUpdateCheckboxForLoggedInUser.push(
                <div id="ReceiveWeeklyUpdateEmails" key="ReceiveWeeklyUpdateEmails" style={{ margin: '0px 0px 20px 0px' }}>
                    <TextField
                        id="ReceiveEmails"
                        className=""
                        type="checkbox"
                        value={receiveEmails}
                        onFieldChanged={(e) => { this.handleFieldChanged("ReceiveEmails", e); }}
                        inline={true}
                        error={this.state.HighlightErrors.ReceiveEmails}
                        errorText={this.state.InputErrors.ReceiveEmails}
                        hasLabel={true}
                    />
                    <div dangerouslySetInnerHTML={{ __html: '<label for="ReceiveEmails">' + this.state.Translations["ReceiveEmails"] + '</label>' }} style={{ display: 'inline' }} />
                </div>
            );
        }
        let AuctionTimePhotoAgreement = [];
        if (this.state.CurrentSite == "AuctionTime" || this.state.CurrentSite == "AuctionValues") {
            AuctionTimePhotoAgreement.push(
                <div key="auctionTimePhotoAgreement" id="PhotoAgreement" style={{ padding: '20px 0px' }}>
                    <span>
                        <span style={{ color: '#D01313' }}>*</span>
                        {this.getTranslation("AuctionTimePhotoAgreement")}
                    </span>
                    <div className="validationError"><span></span></div>
                </div>
            );
        }

        let byContinuingYouAgree = [];
        let byClickingRegister = [];
        if (this.state.IsInTranslationEditorMode) {
            if (this.state.ShowFacebookLoginButton || this.state.ShowGoogleLoginButton) {
                byContinuingYouAgree.push(<div key="continuing-you-agree" style={{ textAlign: 'center', margin: '20px 0px 20px 0px' }}>{this.getTranslation("ByRegisteringWithThirdParty")} {this.getTranslation("termsofuse")} {this.getTranslation("PrivacyPolicy")} {this.getTranslation("CAPrivacyPolicyStatement")} {this.getTranslation("NoticeAtCollection")} {this.getTranslation("ByRegisteringWithThirdParty2")}</div>);
            }
            byClickingRegister.push(<p key="by-clicking-register" style={{ textAlign: 'center' }}>{this.getTranslation("ByClickingSubmitMyAd")} {this.getTranslation("SubmitMyAd")} {this.getTranslation("termsofuse")} {this.getTranslation("ByClickingSubmitMyAd2")}</p>);
        }
        else {
            if (this.state.ShowFacebookLoginButton || this.state.ShowGoogleLoginButton) {
                byContinuingYouAgree.push(<div key="continuing-you-agree" style={{ textAlign: 'center', margin: '20px 0px 20px 0px' }} dangerouslySetInnerHTML={{ __html: this.getTranslation("ByRegisteringWithThirdParty") + " " + this.state.CAPrivacyPolicyNotice + " " + this.getTranslation("ByRegisteringWithThirdParty2") }}></div>);
            }
            byClickingRegister.push(<p key="by-clicking-register" style={{ textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: this.getTranslation("ByClickingSubmitMyAd") }}></p>);
        }

        let MediaOverrideModal =
            <div className="modal" id="media-override-modal">
                <div className="modal-content">
                    <div className="modal-head">
                        <h2>{this.getTranslation("MediaOverride")}</h2>
                        <span className="close" onClick={(e) => { CloseModal(); }}><i className="fa fa-times" aria-hidden="true"></i></span>
                    </div>
                    <div className="modal-main" style={{ textAlign: 'center' }}>
                        <p>{this.getTranslation("InProgressUploadsWillBeDeleted")}</p>
                        <button type="button" role="link" tabIndex="0" className="landing-page-btn PrimaryBGC" onClick={(e) => { CloseModal(); this.props.contactRef.handleButtonClick("submit", true); }}>{this.getTranslation("Continue")}</button>
                    </div>
                </div>
            </div>

        return (
            <form id="regform" onSubmit={(e) => { this.props.contactRef.submitForm(e) }}>
                <div className="accordion cf" id="accordion-content-4">

                    <div className="error-message" id="submissionError" style={{ display: 'none' }}></div>

                    <div className="validationError" style={{ textAlign: 'center' }}>
                        <span>{this.state.InputErrors.LeadPromotion}</span>
                    </div>

                    {WeeklyUpdateCheckboxForLoggedInUser}

                    <div id="SubmitBtn" style={{ display: 'block' }}>
                        { /* Auction Time Photo legal text*/}
                        {AuctionTimePhotoAgreement}
                        <div id="submit-section" style={{ textAlign: 'center', display: 'block' }}>
                            {byClickingRegister}
                            <button type="button" role="link" id="submit-btn" className="submit-btn PrimaryBGC siteFontColor" onClick={(e) => { this.props.contactRef.handleButtonClick(submitAction); }}>{this.getTranslation("Submit")}</button>
                        </div>
                    </div>
                </div>

                {MediaOverrideModal}
            </form>
        );
    }
}

export default SubmissionSection;
global.SubmissionSection = SubmissionSection;